const CCMaterialChoice = () => {
	return (
		<>
			<path
				d="M24.2699 11.935L12.9999 17.305L1.72994 11.935L5.49994 10.135L4.33994 9.58502L0.529941 11.405C0.319941 11.495 0.189941 11.705 0.189941 11.935L0.239941 12.335L4.40994 14.325L0.529941 16.175C0.319941 16.265 0.189941 16.475 0.189941 16.705L0.239941 17.105L12.7499 23.065L13.0399 23.165L25.4799 17.235C25.6899 17.135 25.8199 16.925 25.8099 16.695L25.7599 16.305L21.5899 14.325L25.4799 12.475C25.6899 12.375 25.8199 12.165 25.8099 11.935L25.7599 11.545L21.6599 9.59502L20.4999 10.145L24.2699 11.945V11.935ZM24.2699 16.705L12.9999 22.075L1.72994 16.705L5.56994 14.875L12.7499 18.295L13.0399 18.395L20.4299 14.875L24.2699 16.705Z"
				fill="#002D55"
			/>
			<path d="M13 1.86502L1.72998 7.23502L13 12.605L24.27 7.23502L13 1.86502Z" fill="#BADDF4" />
			<path
				d="M25.9299 7.23501C25.9299 7.04501 25.8199 6.86501 25.6399 6.78501L13.2199 0.865007C13.0899 0.805007 12.9299 0.805007 12.7899 0.865007L0.359946 6.78501C0.189946 6.86501 0.0699463 7.04501 0.0699463 7.23501C0.0699463 7.42501 0.179946 7.60501 0.359946 7.68501L4.34995 9.58501L5.50995 10.135L12.7899 13.605C12.8599 13.635 12.9299 13.655 12.9999 13.655C13.0699 13.655 13.1499 13.635 13.2099 13.605L20.4899 10.135L21.6499 9.58501L25.6399 7.68501C25.8099 7.60501 25.9299 7.42501 25.9299 7.23501ZM12.9999 12.605L1.72995 7.23501L12.9999 1.86501L24.2699 7.23501L12.9999 12.595V12.605Z"
				fill="#002D55"
			/>
		</>
	);
};

export default CCMaterialChoice;
